import { useState } from 'react';
import { formatRSD } from '../lib/helpers';
import { useI18n } from '../lib/i18n';

export default function Products() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [saving, setSaving] = useState(false);

  const addItem = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    setItems((prev) => [...prev, { id: Date.now(), name, price: parseFloat(price) || 0 }]);
    setName('');
    setPrice('');
    setSaving(false);
  };

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));

  return (
    <div>
      <h1 style={styles.heading}>{t('productsHeading')}</h1>
      <p style={styles.sub}>{t('productsSub')}</p>

      <form onSubmit={addItem} style={styles.formRow}>
        <input placeholder={t('serviceNamePlaceholder')} value={name} onChange={(e) => setName(e.target.value)} style={styles.input} />
        <input placeholder={t('priceRsdPlaceholder')} type="number" value={price} onChange={(e) => setPrice(e.target.value)} style={{ ...styles.input, maxWidth: 140 }} />
        <button type="submit" disabled={saving || !name.trim()} style={styles.addBtn}>{t('addItemBtn')}</button>
      </form>

      {items.length === 0 ? (
        <div style={styles.empty}>{t('noItemsYet')}</div>
      ) : (
        <div style={styles.list}>
          {items.map((it) => (
            <div key={it.id} style={styles.row}>
              <span style={styles.itemName}>{it.name}</span>
              <span style={styles.itemPrice}>{formatRSD(it.price)}</span>
              <button onClick={() => removeItem(it.id)} style={styles.removeBtn}>{t('deleteBtn')}</button>
            </div>
          ))}
        </div>
      )}

      <div style={styles.note}>
        {t('productsNote')}
      </div>
    </div>
  );
}

const styles = {
  heading: { fontSize: 22, marginBottom: 8 },
  sub: { fontSize: 13, color: 'var(--ink-500)', marginBottom: 18 },
  formRow: { display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' },
  input: { flex: 1, border: '1.5px solid var(--line)', borderRadius: 10, padding: '11px 13px', fontSize: 14, minWidth: 140 },
  addBtn: { display: 'flex', alignItems: 'center', gap: 6, minHeight: 34, background: 'var(--teal-800)', color: '#fff', border: 'none', borderRadius: 8, padding: '0 14px', fontWeight: 700, fontSize: 13 },
  empty: { textAlign: 'center', padding: '40px 20px', color: 'var(--ink-500)', fontSize: 14 },
  list: { display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 },
  row: { display: 'flex', alignItems: 'center', gap: 12, background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 8, padding: '11px 14px' },
  itemName: { flex: 1, fontWeight: 600, fontSize: 14, color: 'var(--ink-900)' },
  itemPrice: { fontWeight: 600, fontSize: 14, color: 'var(--teal-800)' },
  removeBtn: { border: '1px solid var(--red-600)', background: 'none', borderRadius: 8, padding: '5px 10px', fontSize: 12, color: 'var(--red-600)' },
  note: { fontSize: 12, color: 'var(--ink-500)', lineHeight: 1.5 },
};
